import {
  ControlBlock_SetEthernetSettingsModel,
  ControlBlock_SetSimContextModel,
  ControlBlock_WifiEthernetSettingsModel,
  ControlBlocksService,
  GetSimData_GetSimDataResponse,
  GetWiFiState_GetWiFiStateResponse,
} from "../api";
import {EthernetParams, SimParams, WifiParams, WifiState} from "../components/menu/NetworkSettings/NetworkSetting.model";

const mapWifiState = (response: GetWiFiState_GetWiFiStateResponse): WifiState => ({
  ssid: response.ssid ?? '',
  ip: response.ip ?? '',
  mac: response.mac ?? '',
  rssi: String(response.rssi ?? ''),
});

const mapSimParams = (response: GetSimData_GetSimDataResponse): SimParams => ({
  apn: response.apn ?? '',
  login: response.login ?? '',
  password: response.password ?? '',
});

export const NetworkSettingsApi = {

  //получить параметры интернета
  getEthernetParams: async (id: string): Promise<EthernetParams> => {
    const response = await ControlBlocksService.getApiControlBlocksEthernetLink(id);

    // The current API returns the DHCP flag and values wrapped in
    // `ethernetSettings`. The generated OpenAPI client still describes the
    // response as the older, flat EthernetSettingsModel.
    const ethernetResponse = response as unknown as Partial<EthernetParams>;
    if (ethernetResponse.ethernetSettings) {
      return {
        dhcpEnabled: ethernetResponse.dhcpEnabled ?? false,
        ethernetSettings: ethernetResponse.ethernetSettings,
      };
    }

    return {
      dhcpEnabled: false,
      ethernetSettings: response,
    };
  },

  //обновить параметры интернета
  updateEthernetParams: async (id: string, payload: EthernetParams): Promise<boolean> => {
    const requestBody: ControlBlock_SetEthernetSettingsModel = payload;
    await ControlBlocksService.postApiControlBlocksEthernetLink(id, requestBody);
    return true;
  },

  //получить параметры wifi
  getWifiParams: async (id: string): Promise<WifiParams> => {
    return ControlBlocksService.getApiControlBlocksEthernetWifi(id);
  },

  //получить статус wifi
  getWifiStatus: async (id: string): Promise<WifiState> => {
    const response = await ControlBlocksService.getApiControlBlocksEthernetWifiState(id);
    return mapWifiState(response);
  },

  //получить список сетей wifi
  getNetworksList: async (id: string): Promise<Record<string, string[]>> => {
    const response = await ControlBlocksService.getApiControlBlocksEthernetWifiNetworks(id);
    return {networks: response.networks ?? []};
  },

  //обновить параметры wifi
  updateWifiParams: async (id: string, payload: any): Promise<boolean> => {
    const requestBody: ControlBlock_WifiEthernetSettingsModel = payload;
    await ControlBlocksService.postApiControlBlocksEthernetWifi(id, requestBody);
    return true;
  },

  //получить параметры сим
  getSimParams: async (id: string): Promise<SimParams> => {
    const response = await ControlBlocksService.getApiControlBlocksSim(id);
    return mapSimParams(response);
  },

  //обновить параметры сим
  updateSimParams: async (id: string, payload: SimParams): Promise<boolean> => {
    const requestBody: ControlBlock_SetSimContextModel = payload;
    await ControlBlocksService.postApiControlBlocksSim(id, requestBody);
    return true;
  },

  //рестарт сим
  restartSim: async (id: string): Promise<boolean> => {
    await ControlBlocksService.postApiControlBlocksSimRestart(id);
    return true;
  },



}
